module.exports = __webpack_public_path__ + "img/header-my.0bcdfba6.jpeg";